<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>人员考试管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <!-- <div style="height:13%">
          <el-input
            v-model="search.entName"
            placeholder="请输入企业班组名称"
            style="margin-bottom: 10px; width: 85%;margin-top: 20px;font-size:12px"
            clearable
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div> -->
        <el-card style="height:100%;overflow: auto;">
          <el-tree
             :data="dataTree"
            ref="tree"
            :props="defaultProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px" >
            <!-- <el-button-group style="text-align:right;display:block">
              <el-button plain @click="doFilter(2)"  :class="{cur : search.personStatus==2}">未入职</el-button>
              <el-button plain @click="doFilter(0)"  :class="{cur : search.personStatus==0}">在职</el-button>
              <el-button plain @click="doFilter(1)"  :class="{cur : search.personStatus==1}">离职</el-button>
            </el-button-group> -->
            <div class="grid-search">
              <el-input v-model="search.name" placeholder="请输入姓名" clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div style="display:flex;margin:0px 0px 0px 0px;">
              <el-button type="primary" plain @click="exportWorker">批量操作</el-button>
              <!-- <el-button type="primary" @click="attendVisible = true">批量下发</el-button>
              <el-button type="primary" @click="push">班组配置</el-button>
              <el-button type="primary" @click="outTeam">批量出场</el-button> -->
            </div>
          </div>
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :default-sort="{prop: 'createDate', order: 'descending'}"
              @selection-change="handleSelectionChange"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index+1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="260">
                <template slot-scope="scope">
                  <div style="display:flex;">
                    <img
                      v-if="scope.row.idcardPhoto!=''"
                      :src="scope.row.idcardPhoto"
                      style="width:70px;height:90px;"
                    />
                    <div
                      v-else
                      style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
                    >暂无图片</div>
                    <div style="padding-left:10px;display:flex;flex-wrap:wrap;width:150px;">
                      <p style="width:100%;text-align: left;padding-top: 10px;">{{ scope.row.name}}</p>
                      <p style="width:100%;text-align: left;padding-top: 10px;">{{ scope.row.idcard}}</p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="年龄" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.age }}</span>
                </template>
              </el-table-column>
              <el-table-column label="班组">
                <template slot-scope="scope">
                  <span>{{ scope.row.teamsName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="岗位/工种">
                <template slot-scope="scope">
                  <span>{{ scope.row.typeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="在职状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.outFlag=='0'" style="color:#86A0F3">在职</span>
                  <span v-if="scope.row.outFlag=='1'" style="color:#86A0F3">离职</span>
                  <span v-if="scope.row.outFlag=='2'" style="color:#86A0F3">未入职</span>
                </template>
              </el-table-column>
              <el-table-column label="是否考试">
                <template slot-scope="scope">
                  <span v-if="scope.row.isEducation=='0'" style="color:#F56C6C;">否</span>
                  <span v-else-if="scope.row.isEducation=='1'" style="color:#67C23A;">是</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editEdu(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--配置是否接受教育 表格-->
            <el-dialog
              width="30%"
              title="考试配置"
              :append-to-body="true"
              :lock-scroll="false"
              :visible.sync="classVisible"
            >
              <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="是否接受教育：">
                  <el-radio-group v-model="form.isEducation">
                    <el-radio label="0">未接受</el-radio>
                    <el-radio label="1">已接受</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="classVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitClass()">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      listData: [],
      search: {
        //查询
        name: '',
        projectId: '',
        personStatus: '0', // 0-在职；1-离职；2-未入职
        teamsId: '',
        entId: '',
        entName: '',
      },
      date: '',
      dataText: '数据加载中...',
      dataTree: [], //树形列表
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      attendVisible: false, //考勤机弹出框
      attendData: [], //考勤设备列表
      classVisible: false, //班组弹出框
      classData: [], //班组数据
      classId: '', //班组id
      attendSel: [], //考勤机选择
      personIdStr: '', //人员选择（下发）
      ids: '', //人员信息id（班组配置）
      personIdClass: '', //人员选择(班组配置)
      dataText: '数据加载中...',
      // dialogTitle1:'配置结果',
      // statusper: [
      //   { label: '在职', value: '0' },
      //   { label: '离职', value: '1' }
      // ], //筛选人员状态
      personStu: '0',
      Phone: [],
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0
      // modifyVisible: false,
      // imoportVisible:false,
      // workerInfo: {
      //   id: '',
      //   name: '',
      //   idcard: '',
      //   phone: '',
      //   idcard1: ''
      // },
      typeNameAll: [], //考勤机类型字典表
      workerType: [], //工种列表
      managerType: [] ,//岗位列表
      tableData1:[],
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      //是否接受教育
      form:{
        isEducation:'1',
        sign:true, // 是否单个编辑 true：是   false:批量操作
        id:'',//单个编辑时使用
      },
    }
  },
  mounted() {
    var port = util.session.get('roleId')
    this.getDict()
    this.getClass()
    this.getTypeDict('position') //获取岗位
    this.getTypeDict('worktype') //获取工种
    this.teamTree() //获取组织树
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      this.search.personStatus = index
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.listData = []
      myHttp.getProjectPersonManagerList(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
           // console.log(resp)
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].idcardPhoto =  list[i].idcardPhoto && list[i].idcardPhoto != '' ? base.httpCtx + list[i].idcardPhoto: ''
              list[i].createDate =list[i].createDate && list[i].createDate != '' ? list[i].createDate.split(' ')[0]  : ''
              list[i].age = util.myTime.getAge(list[i].birthday)
            }
            that.listData = list
            that.getTypeName()
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    //获取考勤机
    getAttendList() {
      var that = this
      myHttp
        .getRecogByProjectId1({
          projectId: this.search.projectId
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo || []
            for (var i = 0; i < list.length; i++) {
              list[i].statusName = that.filterSatus(list[i].status)
            }
            that.attendData = list
          }
        })
    },
    //获取类型
    filterSatus(str) {
      var list = this.typeNameAll
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //获取班组
    getClass() {
      var that = this
      myHttp
        .getTeams1({
          projectId: this.search.projectId
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.classData = resp.data.data.pageInfo || []
          }
        })
    },
    //人员表格选择
    handleSelectionChange(val) {
      for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.personIdStr = val[i].personId
        } else {
          this.personIdStr += ',' + val[i].personId
        }
        //班组配置人员
        // if (
        //   undefined == val[i].teamsName ||
        //   '' == val[i].teamsName ||
        //   '0' != val[i].outFlag
        // ) {
        //   if (this.personIdClass == '') {
        //     this.personIdClass = val[i].personId
        //   } else {
        //     this.personIdClass += ',' + val[i].personId
        //   }
        if (this.ids == '') {
          this.ids = val[i].id
        } else {
          this.ids += ',' + val[i].id
        }
        // }
        // this.phone = val
      }
    },
    //考勤机表格选择
    // attendChange(val) {
    //   for (var i = 0; i < val.length; i++) {
    //     if (i == 0) {
    //       this.attendSel = val[i].imei
    //     } else {
    //       this.attendSel += ',' + val[i].imei
    //     }
    //   }
    // },
    //考勤选择后点击确认
    // sumbitAttend() {
    //   var that = this
    //   if (this.personIdStr == '' || this.attendSel == '') {
    //     that.$message.error('请选择下发人员或设备！')
    //     return
    //   }
    //   myHttp
    //     .downWorker({
    //       personIdStr: this.personIdStr,
    //       machineIdStr: this.attendSel
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         that.$message.success('下发成功')
    //         that.attendVisible = false
    //         that.getData()
    //       } else {
    //         that.$message.error(resp.data.msg)
    //       }
    //     })
    // },
    //班组选择
    getRadioRow(index, row) {},
    //班组配置
    sumbitClass: function() {
        var that = this
        var obj = {
          projectPersonId:'',
          isEducation:'',
        }
        if(this.form.sign){
          obj.projectPersonId = this.form.id
        }else{
          obj.projectPersonId = this.ids
        }
        
        obj.isEducation = this.form.isEducation
        myHttp.updatePersonEdu(obj).then(function(resp){
          if(resp.data.code=='200'){
              that.$message.success('操作成功')
              that.classVisible = false
              that.getData()
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      // for (var i = 0; i < this.phone.length; i++) {
      //   if (this.phone[i].phone == '' || undefined == this.phone[i].phone) {
      //     that.$message.error('请到个人档案完善手机号！')
      //     return
      //   }
      // }

      // if (this.personIdClass == '' || this.classId == '') {
      //   that.$message.error('请选择人员！')
      //   return
      // }
     // console.log(this.personIdClass,this.ids)
      // myHttp
      //   .joinTeamsBatch({
      //     teamsId: this.classId,
      //     personIdStr: this.personIdStr,
      //     idStr: this.ids,
      //     operationPerson:util.session.get('user').id
      //   })
      //   .then(function(resp) {
      //     if (resp.data.code == '200') {
      //       that.tableData1 = resp.data.data ||[]
      //       that.classVisible = false
      //       that.getData()
      //       that.imoportVisible = true
      //       for(var i = 0;i<that.tableData1.length;i++){
      //         if(that.tableData1[i].status==0){
      //           that.$message.success(that.tableData1[i].result)
      //         }else{
      //           that.$message.error(that.tableData1[i].result)
      //         }
      //       }
      //     } else {
      //       that.$message.error(resp.data.msg)
      //     }
      //   })
    },
    //个人档案
    // sumbitInfo(row) {
    //   var id = row.personId
    //    var port = util.session.get('roleId')
    //     if(port=='4'){
    //         this.$router.push({name: 'perFile',params: { id: id }})
    //     }else if(port=='5'||port=='3'){
    //         this.$router.push({name: 'perFileEnt',params: { id: id} })
    //      }  
      
    // },
    // 改变人员状态
    // filterName1(e) {
    //   this.search.personStatus = e
    //   this.getData()
    // },
    //修改人员信息
    // modInfo(row) {
    //   this.modifyVisible = true
    //   var that = this
    //   myHttp
    //     .getPersonInfoById({
    //       id: row.personId
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         var data = resp.data.data.person
    //         that.workerInfo = {
    //           id: data.id,
    //           name: data.name,
    //           idcard1: row.idcard,
    //           idcard: data.idcard,
    //           phone: data.phone
    //         }
    //       } else {
    //         that.$message.success(resp.data.msg)
    //       }
    //     })
    // },
    //提交修改信息
    // modifyWorkerInfo() {
    //   var that = this
    //   delete this.workerInfo.idcard1
    //   myHttp.modProjectPerson(this.workerInfo).then(function(resp) {
    //     if (resp.data.code == '200') {
    //       that.$message.success('修改成功')
    //       that.modifyVisible = false
    //       that.getData()
    //     } else {
    //       that.$message.success(resp.data.msg)
    //     }
    //   })
    // },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // }
    //编辑教育状态
    editEdu(row){
        this.classVisible = true
        this.form.isEducation = row.isEducation
        this.form.id = row.id
        this.form.sign = true
    },
    //点击批量操作
    exportWorker() {
      if(this.ids==''){
        this.$message.error('请先选择人员！')
      }else{
        this.classVisible = true
        this.form.isEducation = '1'
        this.form.id = ''
        this.form.sign = false
      }
    },
    //字典表（考勤机类型）
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.typeNameAll = resp.data.data.dictList
            // that.getAttendList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取字典类型
    getTypeDict(type) {
      var that = this
      myHttp.getDictByType({
          type: type
      }).then(function(resp) {
        if (resp.data.code == '200') {
          if (type == 'position') {
            that.managerType = resp.data.data.dictList
          } else {
            that.workerType = resp.data.data.dictList
          }
          that.getTypeName()
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    //展示工种或者岗位
    getTypeName() {
      //var list = this.listData
      if (this.listData.length == 0) {
        return
      }
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].teamsType == '1') {
          this.listData[i].typeName = this.getNameById(
            this.listData[i].teamsWork,
            this.workerType
          )
        } else {
          this.listData[i].typeName = this.getNameById(
            this.listData[i].teamsWork,
            this.managerType
          )
        }
      }
    },
    //获取数据名称
    getNameById(id, list) {
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //点击树形结构
    handleNodeClick(data,data1,data2) {
      if (data.level == '1') {
        this.search.projectId = ''
        this.search.teamsId = ''
        this.search.entId = ''
        this.$refs.tree.setCurrentKey(undefined)
      } else if (data.level == '2') {
        this.search.projectId = data.id
        this.search.entId = ''
        this.search.teamsId = ''
      } else if(data.level == '3'){
        this.search.projectId = data1.parent.data.id
        this.search.entId = data.id
        this.search.teamsId = ''
      }else if(data.level == '4'){
        this.search.projectId = data1.parent.parent.data.id
        this.search.entId = data1.parent.data.id
        this.search.teamsId = data.id
      }
      //console.log(data)
      if (data.status == '2') {
        this.search.personStatus = '2'
      } else {
        this.search.personStatus = this.personStu
      }
      if(this.search.projectId && ''!=this.search.projectId){
        this.getData()
      }
    },
    //获取树形结构
    teamTree() {
      var that = this
      myHttp.getPageListPro({
          entId: util.session.get('groupId'),
          levelType:4
      }).then(function(resp) {
          // console.log(resp)
        if (resp.data.code == '200') {
          var list = resp.data.data.entOfficeProjectMenu || []
          that.dataTree = list
          that.search.projectId= list.length>0?  list[0].id:''
          if (that.dataTree.length > 0) {
            that.currentNodekey = that.dataTree[0].list[0].id
            that.expandedkeys.push(that.dataTree[0].list[0].id)
            that.$nextTick(() => {
              // treeBox 元素的ref   value 绑定的node-key
              that.$refs.tree.setCurrentKey(that.currentNodekey)
            })
            that.search.projectId = that.currentNodekey
          }
          that.getData()
        }
      })
    },
    //树形-根据id获取项目
    getProIdById(id,index,list){
      var result = ''
      for(var i=0;i<list.length;i++){
        if(index>1){
          for(var j=0;j<list[i].list.length;j++){
            if(index==2){
              if(id==list[i].list[j].id){
                result
              }
            }
          }
        }
      }
    },
    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
    push() {
      this.classVisible = true
      this.getClass()
    },
    // exportWorker() {
    //   var token = util.session.get('token')
    //   window.open(
    //     myHttp.exportTeamsPersons +
    //       '?projectId=' +
    //       this.search.projectId +
    //       '&personStatus=' +
    //       this.search.personStatus +
    //       '&teamsId=' +
    //       this.search.teamsId +
    //       '&name=' +
    //       this.search.name +
    //       '&accessToken=' +
    //       token
    //   )
    // },
    handleClose1(done) {
      this.imoportVisible = false
    },
    //批量出场
    outTeam() {
      var that = this
      if (this.personIdStr == '') {
          that.$message.error('请选择工人！')
          return
      }
      this.$confirm('确认工人离场吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          myHttp.outTeamsBatchByProjectId({
              idStr: that.personIdStr,
              projectId: that.search.projectId,
              operationPerson:util.session.get('user').id
          }).then(function(resp) {
              if (resp.data.code == '200') {
              that.$message.success('离场成功')
              that.getData()
              } else {
              that.$message.error(resp.data.msg)
              }
          })
      })
    },
    //个人离场
    handleDelete(index, row) {
        var that = this
        this.$confirm('确认该人员（' + row.name + '）离场吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            myHttp.outTeamsBatch({
                idStr: row.personId,
                teamsId: row.teamsId,
                operationPerson:util.session.get('user').id
            }).then(function(resp) {
                if (resp.data.code == '200') {
                that.$message.success('离场成功')
                that.getData()
                } else {
                that.$message.error(resp.data.msg)
                }
            })
        })
    },

  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 140px);
}
.cur{
  background: #ECF5FF !important;
  /* border: 1px solid   #409EFF !important ; */
  color:#409EFF !important  ;
}
/* .build-CURD>>>.el-card__body{
 height: 100%;
}  */
div >>> .el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center !important;
}
div >>> .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: center;
  box-sizing: border-box;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
}
</style>